import { IListApiRequest, IListApiResponse } from 'api/types'

export enum Language {
  English = 'en',
  Spanish = 'sp'
}
export enum CHANNEL {
  SMS = 'SMS',
  WHATSAPP = 'WHATSAPP',
  INAPP = 'INAPP'
}
export enum CAMPAIGNSTATUS {
  PROCESS = 'Process',
  SCHEDULE = 'Schedule',
  CANCEL = 'Cancel',
  DRAFT = 'Draft'
}
export interface CampaignListParams {
  size?: number;
  page?: number;
  [key: string]: string | number | undefined;
}

export interface Campaign {
  id?: number;
  name: string;
  channelId?: string;
  advname: string;
  channel?: CHANNEL;
  businessInfo?: string;
  phone_id?: string;
  template?: number | string | undefined | any;
  description: string | null;
  scheduleDateTime: Date | string | null;
  status: CAMPAIGNSTATUS;
  templateId: string;
  estimatedUser: number | any;
  templateName?: string;
  language?: string;
  audience: {
    name: string,
    id: number
  };
  scheduleEndDate?: Date | string | null;
  advertisement?: {
    id: number
  };
}

export interface WhatsAppTemplate {
  id: string;
  name: string;
  language: Language;
  status: string;
  createdAt: string;
  updatedAt: string;
}
export interface AppCampaign {
  id?: number;
  name: string;
  description: string | null;
  channel?: CHANNEL;
  scheduleDateTime: Date | string | null;
  status: CAMPAIGNSTATUS;
  scheduleEndDate: Date | string | null;
  template?: {
    id: number
  };
  audience: {
    id: number
  };
  advertisement?: {
    id: number
  };
}

export type CampaignSaveRequest = Campaign
export type AppCampaignSaveRequest = AppCampaign
export type CampaignListRequest = IListApiRequest<Campaign>
export type CampaignListResponse = IListApiResponse<Campaign>
export type AppCampaignListRequest = IListApiRequest<AppCampaign>
export type AppCampaignListResponse = IListApiResponse<AppCampaign>
export type TemplateListRequest = IListApiRequest<WhatsAppTemplate>
export type TemplateListResponse = IListApiResponse<WhatsAppTemplate>
